import useAuthenticatedQuery from "./useAuthenticatedQuery";

const useGetUsers = (queryUrl = "/api/v1/users/all") => {
  const {
    data: users,
    isLoading: usersLoading,
    error: usersError,
    refetch: refetchUsers, // renaming for clarity below
  } = useAuthenticatedQuery(["users-all", queryUrl], queryUrl);

  return { users, refetchUsers, usersLoading, usersError };
};

export default useGetUsers;
